import { AtSign } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { apiClient } from '@/lib/api/client'
import { useAsyncData } from '@/src/hooks/useAsyncData'
import { SignInEmailPanel } from '@/src/components/SignInEmailPanel'

/** The email you sign in with, and changing it: the new address confirms before anything moves. */
export function SignInEmailCard() {
  const { data, error, loading } = useAsyncData(() => apiClient.getSignInEmail(), [])

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <AtSign className="h-5 w-5" />
          Sign-in email
        </CardTitle>
        <CardDescription>
          {data
            ? `You sign in to Helm with ${data.email}. It is also where Xtellar finds your consignments and requests.`
            : 'The email you sign in to Helm with.'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        {loading && <p className="text-sm text-muted-foreground">Loading…</p>}
        {error && (
          <p className="text-sm text-destructive" role="alert">
            Couldn't load your sign-in email.
          </p>
        )}
        {data && (
          <SignInEmailPanel
            idPrefix="account"
            who="self"
            currentEmail={data.email}
            pending={data.pending}
            actions={{
              request: async (newEmail) =>
                (await apiClient.requestSignInEmailChange(newEmail)).pending,
              resend: async () => (await apiClient.resendSignInEmailChange()).pending,
              cancel: async () => {
                await apiClient.cancelSignInEmailChange()
              },
            }}
          />
        )}
      </CardContent>
    </Card>
  )
}
